import { useCatalogQuery } from '~gatsby-theme-autonomy/hooks/graphql/queries/use-catalog'

export const usePreloadedState = () => {
  const { catalog = [] } = useCatalogQuery()
  return { catalog }
}
